/**
 * Desktop Header 内の外部リンク nav。
 * Figma 上は右上に「障害情報 / 機能拡張 / API」等が並ぶ。
 * 今回のモックでは既存 Header にあった外部リンク (Patreon / FANBOX / 保管庫) を流用。
 */
import icon_aimoge from "@/assets/img/icon_aimoge.webp";
import icon_aimoge_dark1 from "@/assets/img/icon_aimoge_dark1.webp";
import icon_blumoge from "@/assets/img/icon_blumoge.webp";

export const DesktopMenu: React.FunctionComponent = () => {
  return (
    <nav className="flex items-center gap-3 text-sm">
      <a
        href="https://www.patreon.com/cw/u32913910"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 text-secondary hover:text-primary transition-colors"
      >
        <img src={icon_aimoge} alt="" className="h-5 w-5" />
        Patreon
      </a>
      <a
        href="https://aimoge.fanbox.cc/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 text-secondary hover:text-primary transition-colors"
      >
        <img src={icon_aimoge_dark1} alt="" className="h-5 w-5" />
        FANBOX
      </a>
      <a
        href="https://wiki.nijiurachan.net/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 text-secondary hover:text-primary transition-colors"
      >
        <img src={icon_blumoge} alt="" className="h-5 w-5" />
        保管庫
      </a>
    </nav>
  );
};
